import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Footer from '@ifeng-fe/container_content/common/client/components/footer';

const BottomFooter = ({ content }) => {
    return (
        <div className={styles.bottomFooter}>
            <Footer content={content.footer} />
        </div>
    );
};

BottomFooter.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(BottomFooter);
